module.exports = __webpack_public_path__ + "static/media/VIC-Regular.1bd011c6.ttf";